import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateSopModulePayloadType,
  DeleteSingleSopDetailsPayloadType,
  GetSingleSopDetailsPayloadType,
  GetSopModulePayloadType,
  GetUniqueCheckSopDetailsPayloadType,
  HideSopPayloadType,
  UpdateSopModulePayloadType,
} from "../../commonTypes/sopModuleTypes";
import {
  createSopModuleListApi,
  deleteSingleSopDetailsApi,
  getSingleSopDetailsApi,
  getSopModuleListApi,
  getUniqueCheckSopFileNameApi,
  hideUnhideSopApi,
  updateSopModuleApi,
} from "../../apis/sopModuleApis";

export const getSopModuleListAction = createAsyncThunk(
  "get/SopModuleList",
  async (data: GetSopModulePayloadType) => {
    const response = await getSopModuleListApi(data);
    return response.data;
  }
);

export const getSingleSopDetailsAction = createAsyncThunk(
  "get/SopSingleModuleList",
  async (data: GetSingleSopDetailsPayloadType) => {
    const response = await getSingleSopDetailsApi(data);
    return response.data;
  }
);

export const getUniqueCheckSopFileNameAction = createAsyncThunk(
  "get/uniqueCheckFileName",
  async (data: GetUniqueCheckSopDetailsPayloadType) => {
    const response = await getUniqueCheckSopFileNameApi(data);
    return response.data;
  }
);

export const deleteSingleSopDetailsAction = createAsyncThunk(
  "delete/SopSingleData",
  async (data: DeleteSingleSopDetailsPayloadType) => {
    const response = await deleteSingleSopDetailsApi(data);
    return response.data;
  }
);

export const createSopModuleListAction = createAsyncThunk(
  "create/SopModuleList",
  async (data: CreateSopModulePayloadType) => {
    const response = await createSopModuleListApi(data);
    return response.data;
  }
);

export const updateSopModuleAction = createAsyncThunk(
  "update/SopModuleList",
  async (data: UpdateSopModulePayloadType) => {
    const response = await updateSopModuleApi(data);
    return response.data;
  }
);

export const hideUnhideSopAction = createAsyncThunk(
  "hideUnhide/SopModuleList",
  async (data: HideSopPayloadType) => {
    const response = await hideUnhideSopApi(data);
    return response.data;
  }
);
